import { render, staticRenderFns } from "./ChatForwarded.vue?vue&type=template&id=fd0031f0&scoped=true"
import script from "./ChatForwarded.vue?vue&type=script&lang=js"
export * from "./ChatForwarded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0031f0",
  null
  
)

export default component.exports